var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.231,
    height: 22.681,
    viewBox: "0 0 24.231 22.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_112607",
    "data-name": "Group 112607",
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x2: 24.231,
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 24.231,
    transform: "translate(0 14.029)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 14.029,
    transform: "translate(0 7.652)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 14.029,
    transform: "translate(0 21.681)",
    fill: "none",
    stroke: "#bbb",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndentIcon);
export default __webpack_public_path__ + "static/media/indent-icon.c561ddea96c80fe883be0f42a1a37e35.svg";
export { ForwardRef as ReactComponent };